import { useEffect, useState } from 'react';
import debounce from '../helpers/debounce';
const useInnerWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handler = debounce(() => setWidth(window.innerWidth), 300);
        window.addEventListener('resize', handler);
        return () => {
            window.removeEventListener('resize', handler);
        };
    }, []);
    return width;
};
export default useInnerWidth;
